import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import Uuid from '../../../../../support/Uuid';
import NominaDeduccionForm from './NominaDeduccionForm';
import NominaDeduccionesList from './NominaDeduccionesList';
import { FormControl } from '../../../../../facturotopia';
import NominaDeduccionesCalculator from '../../../support/nomina/NominaDeduccionesCalculator';

class NominaDeduccionesManager extends Component {
  state = {};

  get rules() {
    return {};
  }

  handleOnAdd = (data) => {
    const { Deducciones = {} } = this.props.data;
    const { Deduccion = [] } = Deducciones;

    const newData = Deduccion.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  handleOnListChange = (data) => {
    const calc = NominaDeduccionesCalculator.make(data).get();

    this.props.onChange({
      ...this.props.data,
      Deducciones: {
        TotalOtrasDeducciones: calc.totalOtrasDeducciones,
        TotalImpuestosRetenidos: calc.totalImpuestosRetenidos,
        Deduccion: data
      }
    });
  }

  render() {
    const { data } = this.state;
    const rules = this.rules;
    const { Deducciones = {} } = this.props.data;
    const { Deduccion = [] } = Deducciones;

    return (
      <>
        <div className="pb-4">
          <div className="section pt-2">
            <div data-testid="nomina-deduccion-form">
              <NominaDeduccionForm
                data={ data }
                onAdd={ this.handleOnAdd }
              />
            </div>

            <div className="pt-2" data-testid="nomina-deduccion-list">
              <NominaDeduccionesList
                data={ Deduccion }
                onEdit={ this.handleOnEdit }
                onChange={ this.handleOnListChange }
              />
            </div>

            <div>
              <strong className="text-muted">
                Resumen de deducciones
              </strong>
            </div>

            <Row>
              <Col sm md={ 4 }>
                <FormControl type="number"
                  label="Total Otras Deducciones"
                  name="TotalOtrasDeducciones"
                  placeholder=""
                  help=""
                  min="0"
                  rules={ rules.TotalOtrasDeducciones }
                  value={ Deducciones.TotalOtrasDeducciones }
                  onChange={ this.handleOnChange }
                />
              </Col>

              <Col sm md={ 4 }>
                <FormControl type="number"
                  label="Total Impuestos Retenidos"
                  name="TotalImpuestosRetenidos"
                  placeholder=""
                  help=""
                  min="0"
                  rules={ rules.TotalImpuestosRetenidos }
                  value={ Deducciones.TotalImpuestosRetenidos }
                  onChange={ this.handleOnChange }
                />
              </Col>
            </Row>
          </div>
        </div>
      </>
    )
  }
}

export default NominaDeduccionesManager;